/**
 * Formats a user's full name from first and last name.
 *
 * Returns trimmed full name, or empty string if no name provided.
 */
export function getUserName(user?: {
  firstName?: string | null;
  lastName?: string | null;
}): string {
  if (!user) {
    return '';
  }

  const firstName = user.firstName || '';

  const lastName = user.lastName || '';

  return `${firstName} ${lastName}`.trim();
}
